import { render, staticRenderFns } from "./AuctionFileDash.vue?vue&type=template&id=5e3871f5"
import script from "./AuctionFileDash.vue?vue&type=script&lang=js"
export * from "./AuctionFileDash.vue?vue&type=script&lang=js"
import style0 from "./AuctionFileDash.vue?vue&type=style&index=0&id=5e3871f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports